const HOUR = 3_600_000;
const DAY = 24 * HOUR;

export interface ConsumptionBucket {
  bucket: string;
  water_consumption: number | null;
  unanchored_count?: number;
  counter_reset_count?: number;
}

export function consumptionLiters(row: ConsumptionBucket): number | null {
  const value = row.water_consumption;
  return typeof value === 'number' && Number.isFinite(value) && value >= 0 ? value : null;
}

/** Daily averages require 24 distinct, valid hourly totals in a past UTC day. */
export function consumptionSummary(rows: ConsumptionBucket[], now = Date.now()) {
  const days = new Map<number, Map<number, ConsumptionBucket>>();
  const duplicateDays = new Set<number>();
  let total: number | null = null;
  for (const row of rows) {
    const value = consumptionLiters(row);
    if (value !== null) total = (total ?? 0) + value;
    const time = Date.parse(row.bucket);
    if (!Number.isFinite(time) || time % HOUR !== 0) continue;
    const day = Math.floor(time / DAY) * DAY;
    if (!days.has(day)) days.set(day, new Map());
    const hours = days.get(day)!;
    if (hours.has(time)) duplicateDays.add(day);
    hours.set(time, row);
  }
  const completeDays = [...days].filter(([day, hours]) =>
    day + DAY <= now && !duplicateDays.has(day) && hours.size === 24 &&
    [...hours.values()].every(row => consumptionLiters(row) !== null && !((row.unanchored_count ?? 0) > 0) && !((row.counter_reset_count ?? 0) > 0))
  );
  const dailyAverage = completeDays.length
    ? completeDays.reduce((sum, [, hours]) => sum + [...hours.values()].reduce((subtotal, row) => subtotal + consumptionLiters(row)!, 0), 0) / completeDays.length
    : null;
  return { total, dailyAverage, completeDays: completeDays.length };
}
